export const ranges = {
  BP: [
    {
      value: 50,
      label: "Low",
      color: "#fac02b",
      icon: (
        <svg className="inline-block h-5 w-5" viewBox="0 0 24 24" fill="#fac02b">
          <path d="M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z" />
        </svg>
      ),
    },
    {
      value: 115,
      label: "Normal",
      color: "#64bd40",
      icon: (
        <svg className="inline-block h-5 w-5" viewBox="0 0 24 24" fill="#64bd40">
          <path d="M22 12l-4-4v3H3v2h15v3z" />
        </svg>
      ),
    },
    {
      value: 130,
      label: "High",
      color: "#dd3923",
      icon: (
        <svg className="inline-block h-5 w-5" viewBox="0 0 24 24" fill="#dd3923">
          <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z" />
        </svg>
      ),
    },
  ],
  HbA1c: [
    { value: 3.5, label: "Optimal", color: "#64bd40" },
    { value: 5.7, label: "Elevated", color: "#fac02b" },
    { value: 6.5, label: "High", color: "#dd3923" },
  ],
};
